// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"467":"8bcff98e","707":"89246308","768":"ba5f50b7"}[chunkId] + ".chunk.css";
};